import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { AppSettings } from '../../../shared/app.settings';
import { UserCommonService } from './../../services/user-common.service';
import { ErrorBindingService } from '../../services/error-binding.service';


@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  @Output() onPopClose: EventEmitter<any> = new EventEmitter();
  @Output() onPopSave: EventEmitter<any> = new EventEmitter();
  @ViewChild('emails') emails: ElementRef;

  editforgotForm = new UntypedFormGroup({
    email: new UntypedFormControl()
  });
  submitted: boolean;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private commonServices: UserCommonService,
    private errorBindingService: ErrorBindingService
  ) {
  }


  ngOnInit() {
    this.editforgotForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(AppSettings.EMAIL_PATTERN)]],
    });
  }

  closeEditForgot(event) {
    this.editforgotForm.reset();
    this.onPopClose.emit();
  }

  setFocus() {
    setTimeout(() => {
      this.emails.nativeElement.focus()
    }, 50)
  }

  changePassword(event) {
    this.submitted = true
    if (this.editforgotForm.valid) {
      let input;
      let otpEmail;
      let otpPhone;

      const userName = this.editforgotForm.controls.email.value;
      if (userName.match(AppSettings.EMAIL_PATTERN)) {
        otpEmail = userName;
        input = {
          email: userName,
          tenantId: AppSettings.TENANT
        };
      } else if (userName.match(AppSettings.PHONE_PATTERN)) {
        otpPhone = userName;
        input = {
          phoneNum: userName,
          tenantId: AppSettings.TENANT
        };
      } else {
        input = {
          username: userName,
          tenantId: AppSettings.TENANT
        };
      }
      this.commonServices.forgotPassword(JSON.stringify(input)).subscribe(results => {
        results.email = otpEmail;
        results.phone = otpPhone;
        this.onPopSave.emit(results);
        this.editforgotForm.reset();
      }, (error) => {
        this.dispalyMessage(error, 'error');
      });
    } else {
      this.errorBindingService.getFormValidationErrors(this.editforgotForm);
    }
  }

  dispalyMessage(msgObj, severity) {
    this.errorBindingService.setMessage({
      severity: severity,
      summary: severity,
      detail: msgObj.general[0].message
    });
  }
}
